import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardFooter } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { StatCard } from '../../components/ui/StatCard';
import { Users, Search, MapPin, CheckCircle, ArrowRight, Heart, Globe } from 'lucide-react';
interface Community {
  id: string;
  name: string;
  location: string;
  members: number;
  actions: number;
  focus: string[];
  verified: boolean;
}
const communitiesData: Community[] = [{
  id: '1',
  name: 'Komunitas Nol Sampah Surabaya',
  location: 'Surabaya, Jawa Timur',
  members: 1250,
  actions: 45,
  focus: ['Edukasi', 'Zero Waste'],
  verified: true
}, {
  id: '2',
  name: 'Bank Sampah Induk Jakarta',
  location: 'Jakarta Selatan, DKI Jakarta',
  members: 5000,
  actions: 120,
  focus: ['Bank Sampah', 'Ekonomi Sirkular'],
  verified: true
}, {
  id: '3',
  name: 'Clean Up Bandung',
  location: 'Bandung, Jawa Barat',
  members: 850,
  actions: 28,
  focus: ['Clean-Up', 'Sungai'],
  verified: true
}, {
  id: '4',
  name: 'Eco Warrior Bali',
  location: 'Denpasar, Bali',
  members: 2100,
  actions: 65,
  focus: ['Marine Debris', 'Edukasi'],
  verified: true
}, {
  id: '5',
  name: 'Pemuda Peduli Lingkungan',
  location: 'Makassar, Sulawesi Selatan',
  members: 450,
  actions: 15,
  focus: ['Sosialisasi', 'Mangrove'],
  verified: false
}, {
  id: '6',
  name: 'Sobat Bumi Medan',
  location: 'Medan, Sumatera Utara',
  members: 620,
  actions: 22,
  focus: ['Edukasi', 'Daur Ulang'],
  verified: true
}];
export function KomunitasPage() {
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans" data-id="element-4474">
      <Header data-id="element-4475" />

      <main className="flex-1" data-id="element-4476">
        {/* Hero Section */}
        <section className="bg-secondary-700 text-white py-16" data-id="element-4477">
          <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-4478">
            <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4479">
              Direktori Komunitas
            </h1>
            <p className="text-lg text-secondary-100 max-w-2xl mx-auto" data-id="element-4480">
              Jejaring komunitas penggerak lingkungan terverifikasi di seluruh
              Indonesia.
            </p>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-8 container mx-auto px-4 md:px-6 -mt-8 relative z-20" data-id="element-4481">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4482">
            <StatCard title="Total Komunitas" value="452" icon={Users} description="Terdaftar Nasional" data-id="element-4483" />
            <StatCard title="Komunitas Aktif" value="380" icon={CheckCircle} description="Bulan Ini" data-id="element-4484" />
            <StatCard title="Total Aksi" value="1,240" icon={Heart} description="Kegiatan Terlaksana" data-id="element-4485" />
          </div>
        </section>

        {/* Search & Content */}
        <section className="py-12 md:py-16 container mx-auto px-4 md:px-6" data-id="element-4486">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8" data-id="element-4487">
            <div className="relative w-full md:w-96" data-id="element-4488">
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-4489" />
              <Input placeholder="Cari nama komunitas atau lokasi..." className="pl-9" data-id="element-4490" />
            </div>
            <div className="flex gap-2 w-full md:w-auto" data-id="element-4491">
              <Select className="w-full md:w-auto" data-id="element-4492">
                <option data-id="element-4493">Semua Wilayah</option>
                <option data-id="element-4494">Jawa</option>
                <option data-id="element-4495">Sumatera</option>
                <option data-id="element-4496">Kalimantan</option>
                <option data-id="element-4497">Sulawesi</option>
                <option data-id="element-4498">Bali & Nusa Tenggara</option>
                <option data-id="element-4499">Maluku & Papua</option>
              </Select>
              <Select className="w-full md:w-auto" data-id="element-4500">
                <option data-id="element-4501">Semua Fokus</option>
                <option data-id="element-4502">Bank Sampah</option>
                <option data-id="element-4503">Edukasi</option>
                <option data-id="element-4504">Clean-Up</option>
                <option data-id="element-4505">Zero Waste</option>
              </Select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4506">
            {communitiesData.map(community => <Card key={community.id} className="hover:shadow-md transition-shadow flex flex-col" data-id="element-4507">
                <CardContent className="p-6 flex-1" data-id="element-4508">
                  <div className="flex justify-between items-start mb-4" data-id="element-4509">
                    <div className="h-12 w-12 rounded-full bg-primary-100 flex items-center justify-center text-primary-600" data-id="element-4510">
                      <Users className="h-6 w-6" data-id="element-4511" />
                    </div>
                    {community.verified && <Badge className="bg-blue-50 text-blue-600 hover:bg-blue-100 border-blue-100 gap-1 pl-1.5" data-id="element-4512">
                        <CheckCircle className="h-3 w-3" data-id="element-4513" />
                        Terverifikasi
                      </Badge>}
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-4514">
                    {community.name}
                  </h3>

                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-4" data-id="element-4515">
                    <MapPin className="h-4 w-4" data-id="element-4516" />
                    {community.location}
                  </div>

                  <div className="flex flex-wrap gap-2 mb-6" data-id="element-4517">
                    {community.focus.map((tag, index) => <Badge key={index} variant="secondary" className="font-normal" data-id="element-4518">
                        {tag}
                      </Badge>)}
                  </div>

                  <div className="grid grid-cols-2 gap-4 pt-4 border-t" data-id="element-4519">
                    <div data-id="element-4520">
                      <p className="text-xs text-gray-500" data-id="element-4521">Anggota</p>
                      <p className="font-semibold text-gray-900" data-id="element-4522">
                        {community.members.toLocaleString()}
                      </p>
                    </div>
                    <div data-id="element-4523">
                      <p className="text-xs text-gray-500" data-id="element-4524">Total Aksi</p>
                      <p className="font-semibold text-gray-900" data-id="element-4525">
                        {community.actions}
                      </p>
                    </div>
                  </div>
                </CardContent>
                <CardFooter className="bg-gray-50 p-4" data-id="element-4526">
                  <Link to={`/komunitas/${community.id}`} className="w-full" data-id="element-4527">
                    <Button variant="outline" className="w-full bg-white hover:bg-gray-50 text-primary-700 border-gray-200" data-id="element-4528">
                      Lihat Profil
                    </Button>
                  </Link>
                </CardFooter>
              </Card>)}
          </div>
        </section>

        {/* CTA Registration */}
        <section className="py-16 bg-primary-50" data-id="element-4529">
          <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-4530">
            <div className="max-w-2xl mx-auto" data-id="element-4531">
              <div className="h-16 w-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6 text-primary-600" data-id="element-4532">
                <Globe className="h-8 w-8" data-id="element-4533" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-4534">
                Komunitas Anda Belum Terdaftar?
              </h2>
              <p className="text-gray-600 mb-8" data-id="element-4535">
                Bergabunglah dengan jaringan nasional penggerak lingkungan.
                Dapatkan akses ke materi eksklusif, undangan event nasional, dan
                peluang kolaborasi.
              </p>
              <Button size="lg" className="bg-primary-600 hover:bg-primary-700 text-white px-8" data-id="element-4536">
                Daftarkan Komunitas
                <ArrowRight className="ml-2 h-4 w-4" data-id="element-4537" />
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-4538" />
    </div>;
}